import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    title: 'Descarga el Kit',
    desc: 'Recibes acceso inmediato al protocolo completo en PDF.'
  }, {
    title: 'Aplica el Perímetro',
    desc: "Instalas el 'Contacto Cero Mental' siguiendo las instrucciones del Día 1."
  }, {
    title: 'Recupera tu Paz',
    desc: 'Usas las herramientas diarias para desactivar la ansiedad y reconstruir tu vida.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-brand-dark" data-id="element-101">
      <div className="max-w-5xl mx-auto" data-id="element-102">
        <FadeIn data-id="element-103">
          <h3 className="font-serif text-3xl md:text-4xl text-white text-center mb-16" data-id="element-104">
            Cómo funciona
          </h3>
        </FadeIn>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-105">
          {/* Timeline steps */}
          <div className="flex-1 w-full" data-id="element-106">
            <div className="space-y-10 relative" data-id="element-107">
              {/* Connecting line */}
              <div className="absolute left-[23px] top-6 bottom-6 w-0.5 bg-brand-amber/15" data-id="element-108" />

              {steps.map((step, i) => <FadeIn key={i} delay={i * 0.15} data-id="element-109">
                  <div className="relative flex items-start gap-5" data-id="element-110">
                    <div className="w-12 h-12 rounded-full bg-brand-dark border-2 border-brand-amber text-brand-amber flex items-center justify-center font-bold text-xl relative z-10 flex-shrink-0 shadow-[0_0_15px_rgba(212,165,116,0.3)]" data-id="element-111">
                      {i + 1}
                    </div>
                    <div className="pt-1.5" data-id="element-112">
                      <h4 className="text-xl font-bold text-white mb-2" data-id="element-113">
                        {step.title}
                      </h4>
                      <p className="text-brand-text/80 leading-relaxed" data-id="element-114">
                        {step.desc}
                      </p>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>

          {/* Image */}
          <FadeIn delay={0.3} data-id="element-115">
            <motion.div className="flex-1 w-full max-w-md lg:max-w-lg" animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-116">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/40 border border-white/5" data-id="element-117">
                <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/40 to-transparent z-10 pointer-events-none" data-id="element-118" />
                <img src="https://cdn.magicpatterns.com/uploads/k9FXtBvv7t1k7mAMyZtJor/heylloyd-image-1775767585587.png" alt="Recupera tu paz interior" className="w-full h-auto object-cover" data-id="element-119" />
              </div>
            </motion.div>
          </FadeIn>
        </div>
      </div>
    </section>;
}